import { render, staticRenderFns } from "./add_word_group.vue?vue&type=template&id=2b833966&scoped=true"
import script from "./add_word_group.vue?vue&type=script&lang=js"
export * from "./add_word_group.vue?vue&type=script&lang=js"
import style0 from "./add_word_group.vue?vue&type=style&index=0&id=2b833966&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b833966",
  null
  
)

export default component.exports